export default __webpack_public_path__ + "static/media/element_9.03b7ff8b.webp";